import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export default function QuizLayout() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#EFF2FE", // page background
        display: "flex",
        justifyContent: "center",
        py: { xs: 2, md: 4 }, // vertical spacing
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1720px", // target width on 1920px screens
          px: { xs: 2, sm: 3, md: 4 }, // responsive horizontal padding
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
